import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdCancel, MdSave } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { findAll } from "../../../../../services/Client__Service";
import {
  save,
  findOne,
  getfile,
} from "../../../../../services/Document__Servive";
import { findAllByClient } from "../../../../../services/Salarie__Service";
import navContext from "../../../../Context/navContext";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";
import {
  ANNEE_TABS,
  MOIS_TABS,
  SIZE_DOC_UPLOAD,
} from "../../../../../services/config";
import PdfRender from "../../../../PdfRender/PdfRender";

const FormDocument = ({ documentId = 0, view = false }) => {
  const notify = useContext(notifyContext);
  const redirect = useNavigate();
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [listClient, setListClient] = useState([]);
  const [listSalarie, setListSalarie] = useState([]);
  const [selectClient, setSelectClient] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingClient, setIsLoadingClient] = useState(true);
  const [doc, setDoc] = useState({
    id: 0,
    mois: new Date().getUTCMonth() + 1,
    annee: new Date().getUTCFullYear(),
    proprietaire: 0,
    date_upload: new Date(),
    statut: 1,
  });
  const nav = useContext(navContext);
  const paramsRoute = useParams();
  const [id, setId] = useState(documentId !== 0 ? documentId : paramsRoute.id);

  useEffect(() => {
    if (paramsRoute["*"] === "edit" && id === 0) redirect("/main/document");
    if (id !== undefined && id > 0) {
      fetchOneDocument(id);
    } else {
      fetchAllClient();
    }
  }, []);

  useEffect(() => {
    let nextValue = "";

    if (document.id === undefined && paramsRoute["*"] === "new")
      nextValue = "Nouveau";
    else {
      if (document.id !== 0) nextValue = "Edition";
    }
    !view &&
      nav({
        links: [
          {
            href: "/main/document",
            linkname: "Bulletins de	paie",
          },
          {
            href: "",
            linkname: nextValue,
          },
        ],
        children: "",
      });
  }, [document]);

  const fetchOneDocument = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setDoc({ ...response.data });
        fecthFile(response.data.chemin);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const fecthFile = async (filename) => {
    getfile(filename)
      .then((response) => {
        setSelectedFile(response.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchAllClient = async () => {
    findAll()
      .then((response) => {
        setListClient(response.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoadingClient(false);
      });
  };
  const fetchAllSalarieByCLient = async (idClient) => {
    findAllByClient(idClient)
      .then((response) => {
        setListSalarie(response.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    fetchAllSalarieByCLient(selectClient);
  }, [selectClient]);

  useEffect(() => {
    if (!isLoadingClient) {
      setIsLoading(false);
    }
  }, [isLoadingClient]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];
    if (selectClient === 0 && doc.id === 0) {
      display_errors.push({
        message: "Veuillez sélectionner une client",
        id_input: "employeur",
      });
    }
    if (doc.proprietaire === 0 && doc.id === 0) {
      display_errors.push({
        message: "Veuillez sélectionner le salarié",
        id_input: "proprietaire",
      });
    }
    if (doc.mois === "") {
      display_errors.push({
        message: "Veuillez sélectionner le mois",
        id_input: "mois",
      });
    }

    if (doc.annee === "") {
      display_errors.push({
        message: "Veuillez sélectionner l'année",
        id_input: "annee",
      });
    }

    if (!isFilePicked && doc.id === 0) {
      display_errors.push({
        message: "Veuillez sélectionner un fichier",
        id_input: "doc",
      });
    } else if (isFilePicked) {
      if (
        [".pdf", "application/pdf"].findIndex((elt) => {
          return elt === selectedFile.type;
        }) === -1
      ) {
        display_errors.push({
          message: "Type de fichier incorrect. (Fichier pdf autorisé)",
          id_input: "doc",
        });
      } else if (selectedFile.size > SIZE_DOC_UPLOAD) {
        display_errors.push({
          message:
            "Taille de fichier très grand (taille ne doit pas dépasser 1Mo)",
          id_input: "doc",
        });
      }
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      save(
        isFilePicked
          ? { ...doc, file: selectedFile }
          : { ...doc, file: undefined }
      )
        .then(() => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
          redirect("/main/document");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setDoc((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  /* FILE HANDLE */
  const [selectedFile, setSelectedFile] = useState(); // contient des informations sur le fichier actuellement sélectionné.
  const [isFilePicked, setIsFilePicked] = useState(false); //détermine si un fichier a été sélectionné ou non.

  const handleChangeFile = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    }
  };

  /* FILE HANDLE END */
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-header">
          {!view && (
            <Fragment>
              <small>
                Les champs comportant <span className="required">*</span> sont
                obligatoires
              </small>
              <div className="error">{error}</div>
            </Fragment>
          )}

          {doc.id !== 0 && (
            <div className="doc__info">
              <p className="create_at">
                Créé le :{" "}
                <span>
                  {" "}
                  {new Date(doc.create_at).toLocaleDateString("fr-FR")}
                </span>{" "}
                à<span> {new Date(doc.create_at).toLocaleTimeString()}</span>
              </p>
              <p className="last_modified">
                {" Dernière modification le : "}
                <span>
                  {" "}
                  {new Date(doc.last_modified).toLocaleDateString("fr-FR")}
                </span>{" "}
                à
                <span> {new Date(doc.last_modified).toLocaleTimeString()}</span>
              </p>
            </div>
          )}
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="employeur" className="form-label">
              Client <span className="required">*</span> :
            </label>
            {doc.id > 0 ? (
              <p>{doc.salarie.client.nom}</p>
            ) : (
              <select
                name="employeur"
                id="employeur"
                className="form-select"
                value={selectClient}
                onChange={(e) => setSelectClient(e.target.value)}
                disabled={doc.id !== 0 || view}
              >
                <option value="0" disabled></option>
                {listClient.map((client) => {
                  const { id, nom } = client;
                  return (
                    <option key={id} value={id}>
                      {nom}
                    </option>
                  );
                })}
              </select>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="proprietaire" className="form-label">
              Salarié <span className="required">*</span> :
            </label>
            {doc.id > 0 ? (
              <p>{doc.salarie.fullname}</p>
            ) : (
              <select
                name="proprietaire"
                id="proprietaire"
                className="form-select"
                value={doc.proprietaire}
                onChange={handleChange}
                disabled={doc.id !== 0 || view}
              >
                <option value="0" disabled>
                  Sélectionner un salarié
                </option>
                {listSalarie.map((salarie) => {
                  const { id, fullname } = salarie;
                  return (
                    <option key={id} value={id}>
                      {fullname}
                    </option>
                  );
                })}
              </select>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="mois" className="form-label">
              Mois <span className="required">*</span> :
            </label>
            <select
              name="mois"
              id="mois"
              className="form-select"
              value={doc.mois}
              onChange={handleChange}
              disabled={view}
            >
              {MOIS_TABS.map((elt, key) => {
                return (
                  <option key={key} value={key + 1}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="annee" className="form-label">
              Année <span className="required">*</span> :
            </label>
            <select
              name="annee"
              id="annee"
              className="form-select"
              value={doc.annee}
              onChange={handleChange}
              disabled={view}
            >
              {ANNEE_TABS.map((item) => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="doc" className="form-label">
              Document <span className="required">*</span> :
            </label>
            {!view && (
              <input
                type="file"
                name="doc"
                id="doc"
                className="form-file"
                //   value={doc.annee}
                onChange={handleChangeFile}
                accept=".pdf, application/pdf,"
              />
            )}
          </div>

          <div className="form-group">
            <label htmlFor="statut" className="form-label">
              Statut <span className="required">*</span> :
            </label>
            <select
              name="statut"
              id="statut"
              className="form-select"
              value={doc.statut}
              onChange={handleChange}
              disabled={view}
            >
              <option value="1">Modifiable</option>
              <option value="0">Archivé</option>
            </select>
          </div>
        </div>

        {!view && (
          <div className="form-footer">
            <button type="submit" className="btn">
              <MdSave />
              Enregistrer
            </button>
            <button type="button" className="btn btn--outline">
              <Link to="/main/document">
                <MdCancel />
                Annuler
              </Link>
            </button>
          </div>
        )}
      </form>
      {selectedFile && (
        <div
          className="preview-pdf"
          style={{
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          <PdfRender file={selectedFile} />
        </div>
      )}
      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormDocument;
